import cubejs from "@cubejs-client/core";
import WebSocketTransport from "@cubejs-client/ws-transport";

export class WsCube {
  get url() {
    return window.$store.state.settings.list.services.value.cube.url;
  }
  get jwt() {
    return window.$store.state.settings.list.services.value.cube.jwt;
  }

  // при смене app необходимо обнулить, чтобы при построении запросов создалось новое соединение
  static cubejsApi = undefined;

  urlWs =
    `ws${location.protocol.substring(4)}//` +
    `${location.host}` +
    `${location.pathname}` +
    `${this.url}` +
    "/";

  constructor() {}

  getCubejsApi() {
    return new Promise((resolve, reject) => {
      if (WsCube.cubejsApi) {
        resolve(WsCube.cubejsApi);
      } else {
        WsCube.cubejsApi = cubejs({
          transport: new WebSocketTransport({
            authorization: this.jwt,
            apiUrl: this.urlWs,
          }),
        });
        resolve(WsCube.cubejsApi);
      }
    });
  }
}
